/* eslint-disable react/jsx-one-expression-per-line */
import React, { ReactElement, useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getStringIndex } from '@utils';
import { getInitiate, checkExistingForm } from '@api';
import gridStyle from '@pages/forms/Grid.module.scss';
import { Accordion, FormLoading } from '@components';
import { useFormikContext } from 'formik';
import VicFinesContext from '@pages/forms/VicFinesFormContext';
import { FormType } from '@constants';
import ClockIcon from '../../../../images/clock.svg';
import styles from './CourtStep0.module.scss';

function CourtStep0(): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const pathElementArray = location.pathname.split('/');
  const stepIndex = getStringIndex(pathElementArray, 'step');
  const stepIndexDiff = stepIndex - pathElementArray.length;
  const pathNameLessLastSegment = stepIndex ? location.pathname.split('/').slice(0, stepIndexDiff).join('/') : location.pathname;
  const { tooltips } = useContext(VicFinesContext);
  const validTitles = Object.keys(tooltips).filter((v) => v.includes('step0'));

  const formikcontext = useFormikContext();
  function getStringForSort(stringVal: string): string {
    return stringVal.substring(stringVal.indexOf('p') + 1, stringVal.indexOf('|'));
  }
  validTitles.sort((stringA, stringB) => Number(getStringForSort(stringA)) - Number(getStringForSort(stringB)));
  useEffect(() => {
    // if resume with #, re - calculate it.
    let pathNameLessLastSegmentOnLoad = '';
    let obNumFromPath = '';
    if (window.location.hash) {
      window.history.pushState({}, '', window.location.pathname + window.location.hash.replaceAll('#', ''));
    }
      const currentUrl = window.location.pathname;
      const pathUrlArray = currentUrl.split('/');
      const stepCurrentIndex = getStringIndex(pathUrlArray, 'step');
      const stepIndexDiffOnLoad = stepCurrentIndex - pathUrlArray.length;
      pathNameLessLastSegmentOnLoad = stepCurrentIndex ? pathUrlArray.slice(0, stepIndexDiffOnLoad).join('/') : currentUrl;
      obNumFromPath = pathUrlArray.includes('step0') && pathUrlArray[stepCurrentIndex + 1] ? pathUrlArray[stepCurrentIndex + 1] : '';
    if (obNumFromPath) {
      setLoading(true);
      checkExistingForm(obNumFromPath, FormType.COURT)
        .then((valueOfExistingform) => {
          let currentStep = '';
          let partialFormID = 0;
          const partialFormOption = valueOfExistingform.CheckingExisting;
          const canSave = valueOfExistingform.CanSave;
          let savingoption = '';
          let debtorID = 0;
          if (partialFormOption === 'no' && valueOfExistingform.DebtorID && valueOfExistingform.PartialFormID) {
            return;
          }
          if (valueOfExistingform.CheckingExisting === 'yes') {
            formikcontext.setFieldValue('SaveYesNo', 'true');
            partialFormID = valueOfExistingform.PartialFormID!;
            formikcontext.setFieldValue('OBLIGATION_NUMBER', obNumFromPath);
            formikcontext.setFieldValue('PartialFormID', partialFormID);
            savingoption = valueOfExistingform.CanSave ? 'yes' : 'no';
          } else {
            debtorID = valueOfExistingform.DebtorID!;
            savingoption = 'no';
            formikcontext.setFieldValue('OBLIGATION_NUMBER', obNumFromPath);
            formikcontext.setFieldValue('DebtorID', debtorID);
          }
          formikcontext.setFieldValue('SaveOptions', savingoption);
          getInitiate(obNumFromPath, FormType.COURT).then((value) => {
            if (value.Number) {
              if (value.Step !== '/step8' && value.Step !== '/step9') {
                // legacy logic
                if (partialFormOption === 'no' && canSave === true) {
                  // go to Which statement best describes you? page - first or third
                  currentStep = '/step3';
                } else {
                currentStep = value.Step;
                }
              }
            } else {
              currentStep = '/step0';
            }
            navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}${currentStep}`);
            setLoading(false);
          });
        })
        .catch(() => {
          navigate(`${pathNameLessLastSegment || pathNameLessLastSegmentOnLoad}/step0`);
          console.log('Caught p2');
        });
    }
    return () => {
      setLoading(false);
    };
  }, []);
  return (
    <>
      {loading && <FormLoading />}
      {!loading && (

      <div className={gridStyle.form}>
        <div className="vfH2">Before you start</div>
        {validTitles.map((v) => {
            const getTitles = v.substring(v.indexOf('|'), v.length).replaceAll('|', ' ');
            return <Accordion title={getTitles} key={v} openByDefault={false} popupContent={tooltips[v]} />;
          })}
        <div className={styles.infoDiv}>
          <img src={ClockIcon} alt="alarm clock" />
          <span className={styles.info}>Please allow up to 12 minutes to complete this form.</span>
        </div>
      </div>
    )}
    </>
  );
}

export default CourtStep0;
